/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, September 2020
 *
 *****************************************************************************/

import React from "react";
import { Marker, Polyline } from "react-google-maps";
import { busMarker } from "../../../shared/utlilty";

// show replay vehicle and its track
const ReplayVehicle = (props) => {
    
  if (props.coordinates.length < 1) return null;

  let vehicle = null;
  let track = null;
  let paths = [];

  for (let c of props.coordinates)
    paths.push({
      lat: c.latitude,
      lng: c.longitude,
    });

  vehicle = (
    <Marker
      clickable={false}
      animation={global.google.maps.Animation.DROP}
      position={{
        lat: paths[paths.length - 1].lat,
        lng: paths[paths.length - 1].lng,
      }}
      icon={{
        url: busMarker(),
        anchor: {
          x: 25,
          y: 25,
        },
      }}
    />
  );

  track = (
    <Polyline
      path={paths}
      draggable={false}
      editable={false}
      options={{
        strokeWeight: 5,
        strokeColor: "blue",
        zIndex: 1,
      }}
    />
  );

  return (
    <>
      {vehicle}
      {track}
    </>
  );
};

export default React.memo(ReplayVehicle);
